import ConfirmDeleteModalUI from '@/components/common/ConfirmDeleteModalUI/ConfirmDeleteModalUI'
import { debounce } from 'lodash'
import { useConfigUI } from '../../context'
import useDeleteFlowValve from '../../hooks/hydraulic/flowValve/useDeleteFlowValve'
import useWaterSourceUsage from '../../hooks/watersource/useWaterSourceUsage'
import toast from 'react-hot-toast'
import useTranslation from '@/hooks/useTranslation'
import { getApiErrorMessage } from '@/helpers/notify'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
}

const DeleteFlowValveView = ({ id, interfaceId }: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()
  const {
    valveUsedBy,
    ready: usageReady,
    error: usageError,
  } = useWaterSourceUsage(Number(interfaceId))
  // Until the water sources are read the map is empty, which would let a
  // used valve through: Confirm waits, and a failed read refuses
  // (SCRUM-1032 review).
  const usageLoading = !usageReady && !usageError

  const { mutate: deleteModal, isLoading: loadingDeleteFlowValve } =
    useDeleteFlowValve()

  const handleDeleteFlowValve = debounce(async () => {
    if (!id) return
    if (!interfaceId) return
    if (!usageReady) {
      toast.error(getApiErrorMessage(usageError, t('somethingWentWrong')))
      closeModal()
      return
    }
    // A water source points at the valve or pump it opens through, so one
    // it uses is refused here rather than at the delete endpoint.
    const usedBy = valveUsedBy.get(Number(id))
    if (usedBy?.length) {
      toast.error(t('flowValveUsedByWaterSource', { names: usedBy.join(', ') }))
      closeModal()
      return
    }
    deleteModal({ interfaceId, id })
  }, 300)

  return (
    <ConfirmDeleteModalUI
      title={t('DeleteFlowValve')}
      text={t('flowValveDeleteConfirmation')}
      onClose={closeModal}
      onConfirm={handleDeleteFlowValve}
      isLoading={loadingDeleteFlowValve || usageLoading}
    />
  )
}

export default DeleteFlowValveView
